'use client';
import SectionWrapper from '../SectionWrapper';
import CarouselWrapper from '@/components/common/CarouselWrapper';
import ReferenceCard from '@/components/home/sections/TestimonialsSection/ReferenceCard';
import { Reference } from '@/actions/directus';
import React from 'react';

interface ReferencesSectionProps {
  references: Reference[];
}

const ReferencesSection: React.FC<ReferencesSectionProps> = ({ references }) => {
  return (
    <SectionWrapper colored={false}>
      <div className="mx-auto flex max-w-7xl flex-col items-center text-center">
        <h2 className="text-3xl font-medium">Unsere zufriedenen Kunden</h2>
        <p className="mt-5 max-w-3xl text-base font-normal">
          Lesen Sie, wie Vergabepilot bereits anderen Kunden bei der Akquise neuer Projekte mittels Ausschreibungen
          geholfen hat.
        </p>
        <CarouselWrapper
          items={references}
          renderCard={(reference: Reference, index: number) => <ReferenceCard reference={reference} key={index} />}
        />
      </div>
    </SectionWrapper>
  );
};

export default ReferencesSection;
